// every field a character sheet can hold, in the order the sheet reads. lists are stored one item per line.
// the form, the lightbox and chi's ocs.md are all built from this one list

export type OcFieldKind = "line" | "list" | "text";

export interface OcField {
  key: string;
  label: string;
  kind: OcFieldKind;
  group: string;
}

export const OC_GROUPS = ["basics", "favourites", "likes", "looks", "identity", "sexuality", "story", "fractal"] as const;

export const OC_FIELDS = [
  { key: "creator", label: "created by", kind: "line", group: "basics" },
  { key: "world", label: "world", kind: "line", group: "basics" },
  { key: "location", label: "location", kind: "line", group: "basics" },
  { key: "race", label: "race", kind: "line", group: "basics" },
  { key: "occupation", label: "occupation", kind: "line", group: "basics" },
  { key: "gender", label: "gender", kind: "line", group: "basics" },
  { key: "rating", label: "sfw / nsfw", kind: "line", group: "basics" },
  { key: "height", label: "height", kind: "line", group: "basics" },
  { key: "food", label: "favourite food", kind: "line", group: "favourites" },
  { key: "smell", label: "smell", kind: "line", group: "favourites" },
  { key: "petPeeve", label: "pet peeve", kind: "line", group: "favourites" },
  { key: "likes", label: "likes", kind: "list", group: "likes" },
  { key: "dislikes", label: "dislikes", kind: "list", group: "likes" },
  { key: "goals", label: "goals", kind: "list", group: "likes" },
  { key: "look", label: "look in short", kind: "line", group: "looks" },
  { key: "body", label: "body", kind: "list", group: "looks" },
  { key: "clothes", label: "clothes", kind: "list", group: "looks" },
  { key: "features", label: "visual features", kind: "list", group: "looks" },
  { key: "speaking", label: "speaking", kind: "text", group: "identity" },
  { key: "personality", label: "personality", kind: "list", group: "identity" },
  { key: "trivia", label: "trivia", kind: "list", group: "identity" },
  { key: "relationships", label: "relationships", kind: "list", group: "identity" },
  { key: "items", label: "items", kind: "list", group: "identity" },
  { key: "skills", label: "skills", kind: "list", group: "identity" },
  { key: "sexuality", label: "sexuality", kind: "line", group: "sexuality" },
  { key: "preferences", label: "preferences", kind: "list", group: "sexuality" },
  { key: "fetishes", label: "fetishes", kind: "list", group: "sexuality" },
  { key: "sexTrivia", label: "sexual trivia", kind: "list", group: "sexuality" },
  { key: "story", label: "story", kind: "text", group: "story" },
  { key: "rpg", label: "rpg sheet", kind: "text", group: "story" },
  { key: "notes", label: "fractal's notes for chi", kind: "text", group: "fractal" }
] as const satisfies readonly OcField[];

export type OcTextKey = (typeof OC_FIELDS)[number]["key"];
export type OcText = Record<OcTextKey, string>;

export const OC_TEXT_MAX = 8000;

export function blankOcText(): OcText {
  return Object.fromEntries(OC_FIELDS.map((field) => [field.key, ""])) as OcText;
}
